import { Outlet } from "react-router-dom";
import JobsHeader from "./JobsHeader";
import "./JobAuthLayout.css";

const JobsAuthLayout = () => {
  return (
    <div className="job-auth-layout-container">
      <JobsHeader />
      <div className='job-auth-layout-wrapper'>
        <main>
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default JobsAuthLayout;
